import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { Container } from '@/app/components/layouts/container';
import { Image } from '@/app/components/media/image';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
export interface ServiceLogisticItemProps {
  image?: string;
  title?: string;
  children?: ReactNode;
  index?: number;
  isReverse?: boolean;
}
export const ServiceLogisticItem = t0 => {
  const $ = _c(31);
  const {
    image,
    title,
    children,
    index: t1,
    isReverse: t2
  } = t0;
  const index = t1 === undefined ? 0 : t1;
  const isReverse = t2 === undefined ? false : t2;
  const currentImage = index + 1;
  const t3 = index === 0;
  const t4 = index > 0;
  let t5;
  if ($[0] !== t3 || $[1] !== t4) {
    t5 = cn("flex flex-col gap-y-6 lg:flex-row lg:gap-x-12", {
      "mt-10": t3,
      "mt-10 lg:mt-16": t4
    });
    $[0] = t3;
    $[1] = t4;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const t6 = `item-${index}`;
  let t7;
  if ($[3] !== t6) {
    t7 = createDataAttributes({
      test: t6
    });
    $[3] = t6;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  const t8 = !isReverse;
  let t9;
  if ($[5] !== isReverse || $[6] !== t8) {
    t9 = cn("flex-1 space-y-6", {
      "order-1 lg:order-2": isReverse,
      "order-1 lg:order-1": t8
    });
    $[5] = isReverse;
    $[6] = t8;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = createDataAttributes({
      test: "content-image"
    });
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  let t11;
  if ($[9] !== currentImage || $[10] !== image) {
    t11 = !!image && <Image className="transform-gpu rounded-md lg:max-w-115 xl:max-w-119" src={image} alt={`Service Logistic Item ${currentImage}`} width={476} height={476} aspectRatio="aspect-1-1" sizes="(min-width: 1024px) 480px, 100vw" />;
    $[9] = currentImage;
    $[10] = image;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== t11 || $[13] !== t9) {
    t12 = <div className={t9} {...t10}>{t11}</div>;
    $[12] = t11;
    $[13] = t9;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  const t13 = !isReverse;
  let t14;
  if ($[15] !== isReverse || $[16] !== t13) {
    t14 = cn("flex-1 lg:self-center", {
      "order-2 lg:order-1": isReverse,
      "order-2 lg:order-2": t13
    });
    $[15] = isReverse;
    $[16] = t13;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = createDataAttributes({
      test: "content-text"
    });
    $[18] = t15;
  } else {
    t15 = $[18];
  }
  let t16;
  if ($[19] !== title) {
    t16 = !!title && <h3 className="text-h3 font-display mb-4 text-red-500 lg:mb-6" dangerouslySetInnerHTML={{
      __html: title
    }} {...createDataAttributes({
      test: "title"
    })} />;
    $[19] = title;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  let t17;
  if ($[21] !== children || $[22] !== t14 || $[23] !== t16) {
    t17 = <div className={t14} {...t15}>{t16}{children}</div>;
    $[21] = children;
    $[22] = t14;
    $[23] = t16;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] !== currentImage || $[26] !== t12 || $[27] !== t17 || $[28] !== t5 || $[29] !== t7) {
    t18 = <Container size="desktop-only" className={t5} data-order={currentImage} data-revealanim={true} {...t7}>{t12}{t17}</Container>;
    $[25] = currentImage;
    $[26] = t12;
    $[27] = t17;
    $[28] = t5;
    $[29] = t7;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  return t18;
};